<template>
  <div style="width:100%;height:100%;display:flex;flex-direction:row">
    <div style="width: 75%;height: 100%;white-space: nowrap;position: relative;">
      <div ref="treeContainer" style="width: 100%;height: 100%;overflow:auto;">
      <vue3-tree-org
          :data="treeData"
          :horizontal="horizontal"
          :toolBar="true"
          :collapsable="collapsable"
          :label-style="style"
          :node-draggable="false"
          :scalable="true"
          :only-one-node="onlyOneNode"
          :default-expand-level="1"
          @on-node-click="onNodeClick"
          :draggable="true"
      >
        <template v-slot="{node}">
          <div class="tree-org-node__text node-label" style="cursor:pointer;">
            <div class="custom-content" :style="node.$$data.business_key ? 'background-color: #108ffe;color:white':''" style="font-size: 18px;">{{ node.label }}</div>
            <div style="text-align: center;font-size: 14px">{{ node.$$data.employee_cnt }}人</div>
            <div class="custom-tree-node">
              <el-avatar :size="medium" shape="square"
                         style="background-color: rgb(162,217,245)"
                         :src="(node.$$data.photo == null || node.$$data.photo.length===0) ? getPngSrc(node.$$data.head) : node.$$data.photo"></el-avatar>
              <div style="float: left;margin-left: 2px;">
                <div style="font-size: 15px;font-weight: bold">{{ node.$$data.head_name }}<span v-if="isBusinessKey(node.$$data.head)">★</span></div>
                <div style="font-size: 14px">{{ node.$$data.head_position }}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 自定义展开按钮 -->
        <template v-slot:expand="{node}">
          <div @click.stop="handleExpand(node)">{{ node.children.length }}</div>
        </template>
      </vue3-tree-org>
      </div>
      <el-button class="export-button" size="small" @click="exportTree">导出组织结构图</el-button>
      <div class="show-data" >最后更新日期：{{ lastUpdateDate }}</div>
    </div>
    <div style="width: 25%;height: auto; display:flex;flex-direction: column;border-left: 1px solid lightgray">
      <div style="height: auto;width: 100%" >
<!--        右侧部门名称-->
        <div style="font-size: 15px;font-weight: bold;margin:10px 0 10px 10px">部门信息：
          <frame-button
              :button="addButton"
              :parent-data="this.currentDept"
          ></frame-button>
          <frame-button
              :button="editButton"
              :parent-data="this.currentDept"
          ></frame-button>
        </div>
        <div class="custom-content" style="font-size: 18px;margin: 0 auto;width: fit-content;white-space: normal;">{{ currentDept.label }}
          <span v-if="currentDept.business_key">★</span>
        </div>
        <div style="text-align: center;font-size: 14px">{{currentDept.employee_cnt}}人</div>
        <div class="custom-tree-node" style="justify-content: center">
          <el-avatar @click="avatarClick(currentDept.head)" shape="square" :size="50" style="cursor:pointer;width: 50px;height: 50px;background-color: rgb(162,217,245)"
                     :src="(currentDept.photo == null || currentDept.photo.length===0) ? getPngSrc(currentDept.head) :currentDept.photo"></el-avatar>
          <div style="float: left;margin-left: 3px;white-space: nowrap;">
            <div style="font-size: 15px;font-weight: bold;">{{currentDept.head_name}}<span v-if="isBusinessKey(currentDept.head)">★</span></div>
            <div style="font-size: 14px">{{currentDept.head_position}}</div>
          </div>
        </div>
        <div style="font-size: 15px;font-weight: bold;margin:10px 0 10px 10px">部门成员：
          <el-button size="small" @click="addCompanyContact(this.currentDept)" >添加职员</el-button>
          <frame-button
              :button="importButton"
              :parent-data="this.currentDept"
          ></frame-button>
        </div>
      </div>
      <el-scrollbar ref="memberContainer" style="overflow: auto;position: relative">
          <div style="margin:0 0 10px 10px;display: flex;justify-content: flex-start;flex-wrap: wrap">
            <div class="dept-tree-node" v-for="deptEmployee in currentDept.deptEmployeeList" :key="deptEmployee.id" >
                <el-avatar shape="square" :size="50" :style="getEmployeeBorderStyle(deptEmployee)"
                           style="cursor:pointer;width: 70px;height: 70px;background-color: rgb(162,217,245)"
                           :src="(deptEmployee.photo == null || deptEmployee.photo.length===0) ? getPngSrc(deptEmployee) : deptEmployee.photo"
                           @error="errorHandler"
                           @click="avatarClick(deptEmployee)">
                </el-avatar>
              <div style="float: left;margin-left: 3px" :style="getEmployeeFontStyle(deptEmployee)">
                <div style="font-size: 14px;font-weight: bold">{{ deptEmployee.name }} <span v-if="deptEmployee.business_key">★</span></div>
                <div style="font-size: 13px">{{ deptEmployee.position_name }}</div>
                <div style="font-size: 13px">{{ deptEmployee.phone_number }}</div>
                <div style="font-size: 13px">{{ deptEmployee.mailbox }}</div>
              </div>
            </div>
          </div>
      </el-scrollbar>
      
    </div>
  </div>

</template>

<script>
import {Vue3TreeOrg} from "vue3-tree-org";
import domtoimage from 'dom-to-image';
export default {
  name: "OrganizationStructure",
  components: {Vue3TreeOrg},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.getDeptTreeData();
        },
      }
    }
  },
  setup(){
    return {
      errorHandler: () => {
        return true;
      }
    }
  },
  data() {
    return {
      treeData: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      lastUpdateDate:'',
      contextMenuVisible:false,
      horizontal: false,
      collapsable: true,
      onlyOneNode: true,
      cloneNodeDrag: true,
      expandAll: true,
      style: {
        background: "#fff",
        color: "#5e6d82",
      },
      contextMenuStyle:{
        top:'0px',
        left:'0px',
      },
      currentMenuEmployee:{},
      currentDept: {},
      addButton: {
        "component": "button",
        "label": "添加部门",
        "size": "small",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameForm",
          "type": "company_organization_node_add",
          "title": "添加部门",
          "width": 900,
          "height": 600
        }
      },
      editButton: {
        "component": "button",
        "label": "编辑部门",
        "size": "small",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameForm",
          "type": "company_organization_node_edit",
          "title": "编辑部门",
          "width": 900,
          "height": 600
        }
      },
      importButton: {
        "component": "button",
        "label": "导入职员",
        "size": "small",
        "click": "jsOpenWindow",
        "window": {
          "component": "frame/FrameForm",
          "type": "sales_chance_tab_contact_import",
          "title": "导入职员",
          "width": 900,
          "height": 600
        }
      },


    };
  },
  created() {
    this.getDeptTreeData();
  },
  methods: {
    onNodeClick(e,data){
      this.currentDept = data;
    },
    // 展开按钮点击处理
    handleExpand(node) {
      node.expand = !node.expand; // 手动切换状态
    },
    //获取部门树
    async getDeptTreeData(){
      let params = this.parentData;
      this.treeData = await this.$http('companyOrganization.getOrgStructureList',params)
      console.log('tree===',this.treeData)
      this.currentDept = this.treeData;
      this.lastUpdateDate = this.treeData.lastUpdateDate

      //显示页面的手机号处理
      if(!this.currentDept.deptEmployeeList || this.currentDept.deptEmployeeList.length === 0){
        return;
      }
      for (let item of this.currentDept.deptEmployeeList) {
        if (item.phones) {
          let dataList = JSON.parse(item.phones);
          if (dataList.length > 0) {
            for (let phoneObj of dataList) {
              if (phoneObj) {
                item.phone_number = phoneObj.phone;
                break;
              }
            }
          }
        }
      }
    },
    // showContextMenu(employee){
    //   event.preventDefault();
    //   this.contextMenuVisible = true;
    //   this.currentMenuEmployee = employee;
    //   // console.log('鼠标x：',event.clientX)
    //   // console.log('鼠标y：',event.clientY)
    //   // 获取当前所在 div 相对于视口的位置
    //   let parentEl = this.$refs.memberContainer.$el;
    //   const parentRect = parentEl.getBoundingClientRect();
    //   // 计算元素相对于当前所在 div 的距离  鼠标的x y 减去窗口的  y轴需要减去滚动的距离
    //   const top = event.clientY - parentRect.top - parentEl.scrollTop;
    //   const left = event.clientX - parentRect.left ;
    //   this.contextMenuStyle.top = top + 'px';
    //   this.contextMenuStyle.left = left + 'px';
    // },
    // handleClick(event) {
    //   // 检查点击的目标是否是编辑或删除按钮
    //   if (!event.target.closest('.editEmployee') && !event.target.closest('.delEmployee')) {
    //     this.hideContextMenu();
    //   }
    // },
    // hideContextMenu() {
    //   this.contextMenuVisible = false;
    // },
    // editEmployee(deptEmployee){
    //   let data = {...deptEmployee};
    //   data.type = 'edit';
    //   this.avatarClick(data)
    //   this.contextMenuVisible = false;
    // },
    // async delEmployee(deptEmployee){
    //   await this.$http('companyOrganization.delCompanyContact',deptEmployee)
    //   this.$message.success("删除成功");
    //   this.getDeptTreeData();
    //   this.contextMenuVisible = false;
    // },
    getPngSrc(deptEmployee){
      if(!deptEmployee){
        return 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png';
      }
      let sex = deptEmployee.sex;
      if(!sex){
        return 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png';
      }
      if(sex === 'male'){
        return '/icon/male.png';
      }else {
        return '/icon/female.png';
      }
    },
    isBusinessKey(employee){
      if(!employee){
        return false;
      }
      return employee.business_key;
    },
    async avatarClick(deptEmployee){
      if(!deptEmployee.name){
        return;
      }
      let data = {...deptEmployee};
      if(!data.type){
        data.type = 'look';
      }
      let windowObj = {}
      windowObj.component = "companyOrganization/CompanyContactUpdate";
      windowObj.name = '职员信息';
      windowObj.parentData = data;
      windowObj.height = 700 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1300 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.getDeptTreeData();
        },
      }

      await this.$store.dispatch('core/openWindow', windowObj)
    },
    addCompanyContact(currentDept){
      let windowObj = {}
      windowObj.component = "companyOrganization/CompanyContactAdd";
      windowObj.name = '添加职员';
      windowObj.parentData = currentDept;
      windowObj.height = 700 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1300 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.$fn = {
        reloadTreeData: () => {
          this.getDeptTreeData();
        },
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },
    exportTree() {
      const zmDraggable = this.$refs.treeContainer.querySelector('.zm-draggable');
      if (zmDraggable && zmDraggable.parentNode) {
        domtoimage.toPng(zmDraggable, {
          width: zmDraggable.scrollWidth,
          height: zmDraggable.scrollHeight,
          bgcolor: '#fff'
        }).then(dataUrl => {
          const img = new Image();
          img.src = dataUrl;
          const canvas = document.createElement('canvas');
          canvas.width = zmDraggable.scrollWidth;
          canvas.height = zmDraggable.scrollHeight;
          const ctx = canvas.getContext('2d');
          img.onload = () => {
            ctx.drawImage(img, 0, 0);
            const imgData = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imgData;
            link.download = this.parentData.company_name + '(组织结构).png';
            link.click();
          };
        }).catch(error => {
          console.error('dom-to-image error:', error);
        });
      } else {
        console.error('zmDraggable is not attached to a Document');
      }
    },
    getEmployeeBorderStyle(employee){
      let status = employee.status;
      let style = "";
      if(status === 'user_status_active'){
        style = "border: 2px #108ffe solid; ";
      }else {
        style = " ";
      }
      return style;
    },
    getEmployeeFontStyle(employee){
      let status = employee.status;
      let style = "";
      if(status === 'user_status_active'){
        style = "color: #108ffe ";
      }else {
        style = "color: #949494 ";
      }
      return style;
    }
  },
};
</script>

<style scoped lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  padding-right: 8px;
  white-space: nowrap;
}

.node-label {
  margin-left: 8px;
}

.tree-org-node__text {
  text-align: left;
  font-size: 14px;
}
.custom-content {
  text-align: center;
  color: black;
  //background-color: #108ffe;
  padding: 0 2px 0 2px;
  white-space: nowrap;
}
:deep(.zoom-container){
  overflow: auto;
}

:deep(.zm-tree-handle){
  left: 10px;
  right: auto;
  bottom: 30px;
}

.dept-tree-node {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  min-width:50%;
  margin-top: 10px;
}
.export-button {
  position: absolute; /* 绝对定位 */
  top: 5px; /* 定位到容器的顶部 */
  right: 10px; /* 定位到容器的右侧 */
  z-index: 10; /* 确保按钮在内容之上 */
}
.show-data {
  font-size: 13px;
  position: absolute; /* 绝对定位 */
  top: 0; /* 定位到容器的顶部 */
  left: 10px; /* 定位到容器的右侧 */
  z-index: 10; /* 确保按钮在内容之上 */
}
.context-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu li {
  padding: 8px 16px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f0f0f0;
}
</style>